import React, {Component} from 'react';

class Submenu extends Component{
    constructor(props, context) {
        super(props, context);
        this.state = {
            activeSection: this.props.activeSection || null,
            activePanel: this.props.activePanel || null
        };
    }
    componentDidUpdate(prevProps, prevState){
        if(this.props === prevProps){
            return false
        }
    }
    changeSection(e){
        let section = e.target ? e.target.id : e ;
        if(e.target){
            e.preventDefault();
        }
        this.props.changeSection(e)
    }
    render(){
        const subMenuSection = [
            {title: "Datos de usuario", id: "userdata", icon:"text-muted fa fa-user", action: this.changeSection.bind(this), active: this.props.activeSection},
            {title: "Direcciones", id: "addresses", icon: "text-muted fa fa-address-book", action: this.changeSection.bind(this), active: this.props.activeSection}
        ]
        const navList = (items) => {
            return items.map( (item, index) => (
                <li key={index} className={index === 0 ? "nav-item active" : "nav-item"}>
                    <a
                        className={item.active === item.id ? "nav-link active " +item.id : "nav-link "+item.id}
                        key={index} id={item.id}
                        href="#"
                        onClick={item.action}
                    >
                        <i className={item.icon}></i>  &nbsp;{item.title}
                    </a>
                </li>
            ));
        };
        return(
            <nav className="row submenu">
                <div className="col-12 sections-menu">
                    <div className="row">
                        <div className="col-md-12">
                            <ul className="nav nav-tabs">
                                {navList(subMenuSection)}
                            </ul>
                        </div>
                    </div>
                </div>
            </nav>
        )
    }
}
export default Submenu;


// WEBPACK FOOTER //
// ./resources/assets/js/components/settings/Submenu.jsx